/*------------------------------------*\
    TABS
\*------------------------------------*/
class Tabs {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.wrapper = self.elem.querySelector('[data-scroll-wrapper]');
        self.scrollbox = self.elem.querySelector('[data-scrollbox]');
        self.scrollToEnd = self.elem.hasAttribute('data-scroll-to-end');

        console.log(self.scrollToEnd);
        
    }

    init() {
        let self = this;
        let isScrolling = false;

        // Function to apply the necessary fade to the tabs container
        function setFade() {
            if (!isScrolling) {
                window.requestAnimationFrame(function () {

                    if (self.scrollbox.scrollLeft > 0) {
                        self.wrapper.classList.add('off-left');
                    }
                    else {
                        self.wrapper.classList.remove('off-left');
                    }

                    if (self.scrollbox.scrollLeft < self.scrollbox.scrollWidth - self.scrollbox.clientWidth) {
                        self.wrapper.classList.add('off-right');
                    }
                    else {
                        self.wrapper.classList.remove('off-right');
                    }

                    isScrolling = false;
                });

                isScrolling = true;
            }
        }

        // On page load
        setFade();
        
        if(self.scrollToEnd) {
            // Scroll to end on page load            
            self.scrollbox.scrollLeft = self.scrollbox.scrollWidth;
        }

        // On scroll
        self.scrollbox.addEventListener('scroll', setFade);

        // On window resize
        window.addEventListener('resize', setFade);
    }

}

export default Tabs;
